import DelayReasonsTabContainer from './DelayReasonsTabContainer';

export default DelayReasonsTabContainer;
